import type { RootState } from 'state';

function getFlightDefinitionGroupVisibleModel(state: RootState): boolean {
  const { visibleModel } = state.flightDefinitionGroups;

  return visibleModel;
}

export default getFlightDefinitionGroupVisibleModel;
